import { render, staticRenderFns } from "./MoonDayWidget.vue?vue&type=template&id=0f45ba3b&scoped=true&"
import script from "./MoonDayWidget.vue?vue&type=script&lang=js&"
export * from "./MoonDayWidget.vue?vue&type=script&lang=js&"
import style0 from "./MoonDayWidget.vue?vue&type=style&index=0&id=0f45ba3b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f45ba3b",
  null
  
)

export default component.exports